module.exports = __webpack_public_path__ + "img/lageplan_640.efc05e32.webp";